import { apiClient } from './api'

export interface AdminSettingsDto {
  applicationName: string
  defaultTimezone: string
  defaultCurrency: string
  defaultAppointmentDuration: number
  bookingWindowDays: number
  emailNotificationsEnabled: boolean
  smsNotificationsEnabled: boolean
  pushNotificationsEnabled: boolean
  sessionTimeoutMinutes: number
  passwordMinLength: number
  defaultCancellationHours: number
  defaultAmendmentHours: number
  allowMultiShopBasket: boolean
}

export const SettingsService = {
  async getPublicSettings(): Promise<AdminSettingsDto> {
    try {
      return await apiClient.get<AdminSettingsDto>('/settings')
    } catch (error) {
      console.error('Failed to fetch public settings:', error)
      throw error
    }
  }
}
